<template>
  <LayoutContent>
    <SectionTitle :label="$t('label.reviewUs')" />
    <v-card class="content d-flex flex-column align-center">
      <div class="text-h5 primary--text text--darken-1 font-weight-bold text-center mb-15">{{ $t('message.submitReviewAcknowledgement') }}</div>
      <img src="@/assets/present.png" class="mb-15" />
      <v-card-actions class="flex justify-center mt-15">
        <v-btn color="primary" class="px-10 rounded-pill green-gradient-right text-capitalize align-self-center" :to="{ name: $constants.ROUTE_NAME.WALLET, params: { tab: 1 } }">
          {{ $t('button.claimRewards') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </LayoutContent>
</template>

<script>
import SectionTitle from '@/components/SectionTitle.vue'
import LayoutContent from '@/views/layouts/LayoutContent.vue'

export default {
  components: { SectionTitle, LayoutContent }
}
</script>
<style lang="scss" scoped>
.content {
  padding-left: 10%;
  padding-right: 10%;
  padding-top: 100px;
  padding-bottom: 40px;

  @media only screen and (min-width: 640px) {
    padding-left: 20%;
    padding-right: 20%;
  }

  @media only screen and (min-width: 1000px) {
    padding-left: 30%;
    padding-right: 30%;
  }
}
</style>
